import { defineStore } from 'pinia';

export const useNavigationStore = defineStore('navigation', {
    state: () => ({
        ausstehendeAenderungenPruefungUeberspringen: false,
        istNavigationAktiv: false,

        /**
         * Ziel-URL der aktuell laufenden Navigation.
         *
         * Problem beim Sliding-Timeout:
         * - Benutzer gibt z. B. `/ergebnisse/schnellsuche?SchnellsucheProbenNr=12345678` ein
         * - router.`beforeEach` startet für diese Ziel-URL
         * - während des Guards werden Kundendaten geladen (API-Request)
         * - Request liefert 401 / 419
         * - Umleitung zur login-Seite
         *
         * In diesem Moment zeigt `router.currentRoute` aber noch auf die aktuelle Route (z.B. "/") und hängt dies dann in der returUrl an.
         *
         * Deshalb speichern wir die beabsichtigte Ziel-URL schon zu Beginn der Navigation separat
         * und der Logout-Mechanismus berücksichtigt dies.
         */
        ausstehendeNavigationReturnUrl: null as string | null
    })
});
